<div class="content">
  <div class="inputRow">
    <label class="inputLabel">Input Type:</label>
    <select class="inputSelection" [(ngModel)]="metricInput" (change)="metricInputChanged()">
      <option [value]="'False'">Imperial</option>
      <option [value]="'True'">Metric</option>
    </select>
    <label class="inputLabel">ESP:</label>
    <input type="number" class="inputValue" [(ngModel)]="updateData.externalStaticPressure"/>
    <label class="unitLabel">{{ getEspUnits() }}</label>
    <label class="inputLabel">Altitude:</label>
    <input type="number" class="inputValue" [(ngModel)]="updateData.altitude"/>
    <label class="unitLabel">{{ getLengthUnits() }}</label>
  </div>
  <div class="inputContainer">
    @if (updateData.hydronicCoolingInputs) {
      <div class="coilRatingContainer">
        <app-schedule-line-performance-coil-input [coilRequest]="updateData.hydronicCoolingInputs"
          [fieldLabel]="getHydronicCoolingInputsLabel()"
          [metricInput]="updateData.isMetric">
        </app-schedule-line-performance-coil-input>
      </div>
    }
    @if (updateData.refrigerantInputs) {
      <div class="coilRatingContainer">
        <app-schedule-line-performance-coil-input [coilRequest]="updateData.refrigerantInputs"
          [fieldLabel]="getRefrigerantInputsLabel()"
          [metricInput]="updateData.isMetric">
        </app-schedule-line-performance-coil-input>
      </div>
    }
    @if (updateData.hydronicHeatingInputs) {
      <div class="coilRatingContainer">
        <app-schedule-line-performance-coil-input [coilRequest]="updateData.hydronicHeatingInputs"
          [fieldLabel]="getHydronicHeatingInputsLabel()"
          [metricInput]="updateData.isMetric">
        </app-schedule-line-performance-coil-input>
      </div>
    }
    <div class="coilRatingContainer">
      @if (updateData.steamInputs) {
        <div class="steamContainer">
          <app-schedule-line-performance-coil-input [coilRequest]="updateData.steamInputs"
            [fieldLabel]="getSteamInputsLabel()"
            [metricInput]="updateData.isMetric">
          </app-schedule-line-performance-coil-input>
        </div>
      }
      @if (updateData.electricHeatInputs) {
        <div class="electricHeatContainer">
          <app-schedule-line-performance-coil-input [coilRequest]="updateData.electricHeatInputs"
            [fieldLabel]="getElectricHeatInputsLabel()"
            [metricInput]="updateData.isMetric">
          </app-schedule-line-performance-coil-input>
        </div>
      }
    </div>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button matButton="elevated" class="dialogButton warn-button" (click)="cancel()">
      <span>
        <mat-icon class="size-16">cancel</mat-icon>
        <label class="buttonLabel">Cancel</label>
      </span>
    </button>
    <button matButton="elevated" class="dialogButton primary-button" (click)="save()">
      <span>
        <mat-icon class="size-16">save</mat-icon>
        <label class="buttonLabel">Update</label>
      </span>
    </button>
  </div>
</div>
